import React from 'react';
import { Translate } from "react-localize-redux";
import { isNullOrUndefined } from "../../../store/storeFunctions";
import PropTypes from 'prop-types';

class BasicRow extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        value: PropTypes.any,
        dataType: PropTypes.oneOf(["text", "array", "money"]),
        className: PropTypes.string,
        doNotTranslateTitle: PropTypes.bool,
        additionalData: PropTypes.object,
    };

    static defaultProps = {
        title: undefined,
        value: undefined,
        dataType: "text",
        className: "ident-item",
        doNotTranslateTitle: false,
        additionalData: null
    };

    render() {
        const { title, value, dataType, className, doNotTranslateTitle, additionalData } = this.props;

        if (isNullOrUndefined(value))
            return null;

        if (dataType === "array" && value.length === 0)
            return null;

        if (dataType === "money" && (isNullOrUndefined(additionalData) || isNullOrUndefined(additionalData.currency)))
            return null;

        return (
            <div className={className}>
                <span>{doNotTranslateTitle ? title : <Translate id={title} />}</span>
                <span>
                    {dataType === "text" && value}
                    {dataType === "array" &&
                        <span>
                            {value.map((x, i) => i > 0 ? ` ,${x.value}` : x.value)}
                        </span>
                    }
                </span>
            </div>
        )
    }
}

export default BasicRow;